export default function Error404() {
  return (
    <div className="max-w-[1328px] mx-auto px-4">
      <p style={{margin: '40px 0'}}>404. Page Not Found</p>
    </div>
  );
}
